"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  restoring: false,
  disabledFeatures: ['typography', 'end-user-filters'],
  dataSync: false,
  map: null,
  initialized: false,
  dataset: null,
  advanced: false,
  enableSave: true,
  widget: null,
  widgetData: [],
  errors: null
};
exports["default"] = _default;